"use client";
import { parseThemeColor } from "../parse-theme-color/parse-theme-color.mjs";
//#region packages/@mantine/core/src/core/MantineProvider/color-functions/get-theme-color/get-theme-color.ts
function getThemeColor(color, theme) {
	const parsed = parseThemeColor({
		color: color || theme.primaryColor,
		theme
	});
	return parsed.variable ? `var(${parsed.variable})` : color;
}
//#endregion
export { getThemeColor };

//# sourceMappingURL=get-theme-color.mjs.map